import { recommendClient } from '@algolia/recommend';

const DEFAULT_TIMEOUTS = { connect: 5000, read: 5000, write: 5000 };

/** Dedicated Recommend client — import from `@algolia/recommend` (not the browser `algoliasearch` bundle). */
export function createRecommendClient(appId: string, apiKey: string) {
  return recommendClient(appId, apiKey, { timeouts: DEFAULT_TIMEOUTS });
}
